import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import store from '../store/store';

interface ProtectedRouteProps {
  element: ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const state = store.getState();
  const token = state.login.token;
  //const token = localStorage.getItem('token');
  return token ? element : <Navigate to='/login' replace />;
};

export default ProtectedRoute;
